@if ({steps: computedSteps(), activeStep: activeStep()}; as ctx) {
  <ul class="isolate flex">
    @for (step of ctx.steps; track step; let i = $index, last = $last) {
      <li class="relative flex flex-1 flex-col gap-2xs">
        <div class="flex h-[40px] items-center justify-center">
          @if (!last) {
            <div
              class="absolute left-1/2 h-[5px] w-full rounded-sm"
              [class.bg-grey-100]="!step.done && !step.skipped"
              [class.bg-green-300]="step.done || step.skipped"
            ></div>
          }
          <div
            class="z-10 mx-2xl flex items-center justify-center rounded-full text-white"
            [ngClass]="{
              done: step.done,
              active: step.active,
              skipped: step.skipped,
              default: !step.active && !step.done && !step.skipped,
            }"
          >
            @if (step.active) {
              @if (step.icon) {
                <fa-icon [icon]="step.icon"></fa-icon>
              } @else {
                <span>{{ i + 1 }}</span>
              }
            }

            @if (step.done) {
              <fa-icon [icon]="checkMarkIcon"></fa-icon>
            }

            @if (step.skipped) {
              <fa-icon [icon]="skipIcon" size="sm"></fa-icon>
            }
          </div>
        </div>
        <div
          class="step-text"
          [attr.data-active-step]="step.active ? step.text : false"
          [class.text-primary]="step.active"
          [class.text-grey-700]="!step.active"
        >
          {{ step.text }}
        </div>
      </li>
    }
  </ul>
}
